// components/PurchaseReceipt.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPurchaseDetail } from '../services/api';
// Similar imports as InvoiceTemplate

const PurchaseReceipt = () => {
  <div>Purchase Receipt Component</div>
  const { id } = useParams();
  const [purchase, setPurchase] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const purchaseRes = await getPurchaseDetail(id);
        setPurchase(purchaseRes);
      } catch (error) {
        console.error('Error loading receipt:', error);
      }
    };
    fetchData();
  }, [id]);

  // Similar structure to InvoiceTemplate but for purchases
  // Include supplier details, batch info, etc.
  // ...
};

export default PurchaseReceipt;